import { render, staticRenderFns } from "./ReviewModificationRecordTable.vue?vue&type=template&id=8e9c8ae6&"
import script from "./ReviewModificationRecordTable.vue?vue&type=script&lang=js&"
export * from "./ReviewModificationRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports